"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = function _default(row) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'mapping';
  return Object.keys(row).filter(function (key) {
    return key.startsWith(prefix + '.');
  }).map(function (key) {
    var label = key.replace(prefix + '.', '');
    var code = row[key];
    return {
      label: label,
      code: code
    };
  });
};
exports["default"] = _default;